<template>
  <a class="row align-items-center mb-3" :href="task.detailsPageUrl">
    <div class="col col-auto p-0">
      <DragIcon v-if="isSubtask"/>
      <CheckedRoundedIcon :success="task.status === 'completed'" v-else/>
    </div>
    <div class="col">
      <div class="admin-task-title">{{ task.title }}</div>
      <div class="admin-task-subtitle" v-if="task.totalScreenshots > 0">
        <span style="margin-right: 8px;"><TaskIcon/></span>
        <span class="font-weight-bold" style="margin-right: 4px;">{{ task.totalScreenshots }}</span> screenshots
      </div>
    </div>
    <div class="col col-auto">
      <div class="admin-task-time">{{ task.totalTime }}</div>
    </div>
    <div class="col col-auto">
      <task-status-badge :status="task.status"></task-status-badge>
    </div>
  </a>
</template>

<script>
import CheckedRoundedIcon from '../icons/CheckedRoundedIcon';
import DragIcon from '../icons/DragIcon';
import TaskIcon from '../icons/Tasks/TaskIcon';

export default {
  components: { TaskIcon, DragIcon, CheckedRoundedIcon },

  props: {
    task: {
      required: true,
      type: Object,
    },
    isSubtask: {
      required: false,
      default: false,
    },
  },
};
</script>

<style scoped lang="scss">
.admin-task-title {
  color: #303030;
  font-family: "Open Sans", sans-serif;
  font-size: 14px;
  letter-spacing: 0;
  line-height: 22px;
}

.admin-task-subtitle {
  display: flex;
  color: #8997aa;
  font-family: "Open Sans", sans-serif;
  font-size: 12px;
  letter-spacing: 0;
  line-height: 22px;
}

.admin-task-time {
  color: #8997aa;
  font-family: "Open Sans", sans-serif;
  font-size: 14px;
  font-weight: 600;
  letter-spacing: 0;
  line-height: 19px;
  text-align: right;
}
</style>
